import styled from 'styled-components';

export const PopupContainer = styled.div`
  max-width: 450px;
  margin: auto;
  @media (max-width: 450px) {
    width: 100vw;
  }
`;

export const SizeImage = styled.img`
  width: 370px;
  height: 370px;

  @media (max-width: 380px) {
    width: 320px;
    height: 320px;
  }
`;
